<template>
  <div class="">
    <company-sectors-edit> </company-sectors-edit>
  </div>
</template>

<script>
import CompanySectorsEdit from "@/components/profile/sectors/company/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    CompanySectorsEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Comparti di compagnia",
        path: "module.PROF.COMP",
        tab: "CompanySectors",
        level: 3,
      });
      bcs.push({
        text: "Modifica Comparto di compagnia",
        path: "sectors.edit1",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Comparti di compagnia",
        path: "module.PROF.COMP",
        tab: "CompanySectors",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Comparto di compagnia",
        path: "sectors.edit1",
        level: 4,
      });
    }
  },
};
</script>
